/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class IdentityFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return IdentityFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<IdentityFeatureFlagsWithDefaults>): IdentityFeatureFlagsWithDefaults {
        let obj = Object.assign(new IdentityFeatureFlagsWithDefaults(), model);
        IdentityFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<IdentityFeatureFlagsWithDefaults>): IdentityFeatureFlagsWithDefaults {
        if (!model) return null;
        return IdentityFeatureFlagsWithDefaults.newInstance(<IdentityFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: IdentityFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.IdentityFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: IdentityFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, IdentityFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    iden_2601_a_scim_2_0_provisioning: boolean = false;

    /**
     * Flag's default value
     */
    iden_2603_f_tenant_rename_enabled: boolean = false;

    /**
     * Flag's default value
     */
    iden_2603_a_saved_views: boolean = true;

}
